export default __webpack_public_path__ + "static/media/TimberTradeTrajectory.d1ca0cff.jpeg";